// apps/web/src/features/commercial-proposals/publicLink.ts
//
// @aiPurpose build the absolute, shareable public URL for a PUBLISHED
//   proposal from the authenticated detail response's `publicLink` (#1198).
// @aiSecurity the token rides in the URL FRAGMENT (the backend builds
//   `publicLink.path` as `/p#t=<token>`), so it is never sent to the server
//   in a query string and never lands in access logs or a `Referer` header.
//   We prepend only the current origin; the path shape stays
//   backend-authoritative so a future change to the fragment scheme is made
//   once, server-side. Repeatable: it derives from the persisted detail
//   response, NOT a one-time publish payload, so it works after refresh.
import type { CommercialProposalPublicLink } from '@magimp/shared';

export function buildPublicUrl(link: CommercialProposalPublicLink): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${link.path}`;
}
